import { emitCollapsedEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking, featureIndex, parentTrackingId) => {
    const { labels } = cinemaTracking;
    return {
        ...cinemaTracking,
        position: parseInt(featureIndex, 10),
        parentId: parentTrackingId,
        status: "collapsed",
        labels,
    };
};

export default (cinemaTracking, featureIndex, parentTrackingId) => {
    const event = [buildCinema(cinemaTracking, featureIndex, parentTrackingId)];
    emitCollapsedEvent(event);
};
